import { NetIncomeType } from '@nemuru-eng/js-api-client';

import { Text } from '../../../shared/components/Text';

export const NetIncomeTypeOptions = Object.values(NetIncomeType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
